import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import {
  Package,
  ShoppingCartState,
} from '../../../shopping-cart-back/actions/standalone';
import { select, Store } from '@ngrx/store';
import { selectPackagesInShop } from '../../../shopping-cart-back/actions/selector';
import { ViewPackageComponent } from '../view-package/view-package.component';
import { ZalamoDialogService } from '../../../../zalamo-dialog/zalamo-dialog.service';
import { map, takeUntil } from 'rxjs/operators';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { translationProvider } from '@ui/nls/translations/translate.directive';

@Component({
    selector: 'lib-packages-list',
    templateUrl: './packages-list.component.html',
    styleUrls: ['./packages-list.component.scss'],
    providers: [translationProvider('productFront')],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PackagesListComponent implements OnInit {
  packageInShop$ = this.store.pipe(select(selectPackagesInShop));
  @Input() matchingPackage: Array<Package> = [];
  @Input() notMatchingPackage: Array<Package> = [];
  @Output() closeWindow = new EventEmitter();
  @Output() addPackage = new EventEmitter();
  id = '';
  isPhonePortrait$ = this.screenObserver
    .observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape])
    .pipe(map(({ matches }) => matches));

  constructor(
    private screenObserver: BreakpointObserver,
    private store: Store<{ shoppingCart: ShoppingCartState }>,
    private dialogService: ZalamoDialogService
  ) {}

  ngOnInit(): void {}

  viewButton(id) {
    return (this.id = id);
  }

  closeViewButton() {
    return (this.id = '');
  }

  openPackageDetail(packageId) {
    const ref = this.dialogService.openFull(ViewPackageComponent);
    this.isPhonePortrait$
      .pipe(takeUntil(ref.afterClosed()))
      .subscribe((isPhonePortrait) => {
        ref._containerInstance.isBare = isPhonePortrait;
      });
    if (this.matchingPackage.find((value) => value.packageId === packageId)) {
      ref.componentInstance.package = this.matchingPackage.find(
        (value) => value.packageId === packageId
      );
    }
    if (
      this.notMatchingPackage.find((value) => value.packageId === packageId)
    ) {
      ref.componentInstance.package = this.notMatchingPackage.find(
        (value) => value.packageId === packageId
      );
    }
    ref.componentInstance.hideDialog
      .pipe(takeUntil(ref.afterClosed()))
      .subscribe(() => {
        ref.close();
      });
    ref.componentInstance.addPacketToBasket
      .pipe(takeUntil(ref.afterClosed()))
      .subscribe(() => {
        this.addPackage.emit(packageId);
        ref.close();
      });
  }
}
